import { useTheme } from "../contexts/ThemeContext";

export default function LassoToolIcon({
    fillClassName,
}: {
    fillClassName: string;
}) {
    const { theme } = useTheme();
    return (
        <svg
            width="16"
            height="14"
            viewBox="0 0 16 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.80893 11.0109C3.14222 11.0109 0.159393 8.55318 0.159393 5.53066C0.159393 2.50815 3.14222 0.0504456 6.80893 0.0504456C10.4756 0.0504456 13.4585 2.50815 13.4585 5.53066C13.4585 8.55318 10.4756 11.0109 6.80893 11.0109ZM6.80893 1.57697C3.98486 1.57697 1.68592 3.35079 1.68592 5.53066C1.68592 7.71054 3.98486 9.48436 6.80893 9.48436C9.633 9.48436 11.9319 7.71054 11.9319 5.53066C11.9319 3.35079 9.633 1.57697 6.80893 1.57697Z"
                fill={fillClassName}
            />
            <path
                d="M10.6374 12.8458C10.2589 12.8458 9.93219 12.5893 9.8406 12.2229L8.57358 7.09076C8.51252 6.84346 8.56748 6.59006 8.72318 6.38856C8.87889 6.18706 9.11397 6.0741 9.36737 6.0741C9.43454 6.0741 9.50171 6.08326 9.56582 6.09852L14.698 7.36554C14.985 7.43576 15.2109 7.65557 15.2903 7.93951C15.3697 8.22344 15.2903 8.52875 15.0796 8.73941L11.2145 12.6046C11.0588 12.7603 10.8542 12.8458 10.6374 12.8458Z"
                fill={fillClassName}
            />
            <path
                d="M9.36737 6.51068C9.3979 6.51068 9.42843 6.51374 9.45896 6.5229L14.5911 7.78991C14.8781 7.86013 14.9789 8.22039 14.7682 8.43105L10.903 12.2962C10.8267 12.3725 10.729 12.4092 10.6344 12.4092C10.4695 12.4092 10.3077 12.3023 10.2619 12.1191L8.99489 6.98696C8.93383 6.73966 9.12617 6.51374 9.36431 6.51374M9.36431 5.63751C8.97658 5.63751 8.61632 5.81459 8.37513 6.11989C8.13699 6.4252 8.0515 6.81904 8.14615 7.19457L9.41316 12.3267C9.5536 12.8885 10.0543 13.2823 10.6344 13.2823C10.9702 13.2823 11.2847 13.1511 11.5228 12.9129L15.388 9.04777C15.7085 8.7272 15.8307 8.25703 15.7116 7.82044C15.5895 7.38386 15.2414 7.04497 14.8018 6.93811L9.66962 5.6711C9.56887 5.64667 9.46812 5.63446 9.36737 5.63446L9.36431 5.63751Z"
                fill={theme === "dark" ? "#7A8590" : "#CEE0EF"}
            />
            <path
                d="M3.95435 10.7208C4.71818 10.7208 5.33738 10.1016 5.33738 9.3378C5.33738 8.57398 4.71818 7.95477 3.95435 7.95477C3.19052 7.95477 2.57132 8.57398 2.57132 9.3378C2.57132 10.1016 3.19052 10.7208 3.95435 10.7208Z"
                fill={theme === "dark" ? "#7A8590" : "#CEE0EF"}
            />
            <path
                d="M3.95434 11.4841C2.76975 11.4841 1.80804 10.5224 1.80804 9.3378C1.80804 8.15322 2.76975 7.19151 3.95434 7.19151C5.13892 7.19151 6.10063 8.15322 6.10063 9.3378C6.10063 10.5224 5.13892 11.4841 3.95434 11.4841ZM3.95434 8.71804C3.6124 8.71804 3.33457 8.99586 3.33457 9.3378C3.33457 9.67975 3.6124 9.95757 3.95434 9.95757C4.29628 9.95757 4.5741 9.67975 4.5741 9.3378C4.5741 8.99586 4.29628 8.71804 3.95434 8.71804Z"
                fill={fillClassName}
            />
            <path
                d="M4.2077 10.7208C4.2077 10.7208 4.2077 12.3206 6.59824 12.2016L4.2077 10.7208Z"
                fill={fillClassName}
            />
            <path
                d="M6.35401 12.974C5.40146 12.974 4.65346 12.7236 4.13139 12.226C3.46583 11.591 3.44751 10.8094 3.44751 10.7239C3.44751 10.3026 3.78945 9.96063 4.21077 9.96063C4.63209 9.96063 4.96487 10.2934 4.97403 10.7056C4.98319 10.8491 5.11142 11.5116 6.56467 11.4444C6.9921 11.4261 7.3432 11.7497 7.36457 12.168C7.38594 12.5893 7.05926 12.9465 6.641 12.9679C6.5433 12.974 6.44865 12.974 6.35706 12.974H6.35401Z"
                fill={fillClassName}
            />
        </svg>
    );
}
